import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom'

import SearchBar from './SearchBar';
import Credentials from './Credentials';

import User from '../services/User';
import Notification from '../services/Notification.js'

import '../../css/Header.css';

class Header extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      showLogin: false,
      showMenu: false
    }

    User.initialize({onChangeCb: () => {
      this.setState({});
    }});

  }

  componentWillReceiveProps() {
    this.hideMenu();
  }

  login() {
    this.setState({showLogin: true});
  }

  hideLogin() {
    this.setState({showLogin: false});
  }

  logout() {
    Notification.show(`See you soon, ${User.getName()}`, 'success');
    User.clearSession();
    this.props.history.push('');
  }

  toggleMenu() {
    this.setState({showMenu: !this.state.showMenu})
  }

  hideMenu() {
    this.setState({showMenu: false})
  }

  render() {

    let loggedIn = User.isLoggedIn();

    return (
      <div>
        <nav id="header">

          <Link to="/"><div className="logo"></div></Link>

          <SearchBar/>

          <span id="menu">

            <i className="fontastic clickable icon-menu" onClick={this.toggleMenu.bind(this)}></i>

            <div className={`items ${this.state.showMenu ? 'active' : ''}`}>

              <ul>

                <li className="clickable"><Link to="/explore">Explore</Link></li>
                {loggedIn && <li className="clickable"><Link to="/about">About</Link></li>}

                {!loggedIn && <li className="clickable" onClick={ () => { this.login() || this.hideMenu() } }>Login</li>}
              
                {loggedIn && <li className="clickable"><Link to={`/users/${User.getId()}`} onClick={this.hideMenu.bind(this)}>{User.getName()}</Link></li>}
                {loggedIn && <li className="clickable" onClick={ () => { this.logout() || this.hideMenu() } }>Logout</li>}

              </ul>

            </div>


          </span>

        </nav>
        <Credentials form={'login'} show={this.state.showLogin} onClose={this.hideLogin.bind(this)}/>
      </div>)
  }

}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/js/components/Header.jsx